var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm._m(0)
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", [
      _c("h1", { staticClass: "h3 bar tertiary" }, [_vm._v("Privacy Policy")]),
      _vm._v(" "),
      _c("div", { staticClass: "container my-5" }, [
        _c(
          "p",
          {
            staticStyle: {
              "margin-top": "0in",
              "margin-right": "0in",
              "margin-bottom": "12pt",
              "margin-left": "0in",
              "line-height": "19.2pt",
              "font-size": "15px",
              "font-family": "'Calibri', sans-serif",
              "text-align": "center",
            },
          },
          [
            _c("strong", [
              _c(
                "span",
                {
                  staticStyle: {
                    "font-size": "16px",
                    "font-family": "Calibri, sans-serif",
                  },
                },
                [
                  _vm._v(
                    "\n                    Global Space Exchange, Inc. \n                "
                  ),
                ]
              ),
            ]),
          ]
        ),
        _vm._v(" "),
        _c(
          "p",
          {
            staticStyle: {
              "margin-top": "0in",
              "margin-right": "0in",
              "margin-bottom": "12pt",
              "margin-left": "0in",
              "line-height": "19.2pt",
              "font-size": "15px",
              "font-family": "'Calibri', sans-serif",
              "text-align": "center",
            },
          },
          [
            _c("span", { staticStyle: { "font-size": "16px" } }, [
              _c(
                "span",
                { staticStyle: { "font-family": "Calibri, sans-serif" } },
                [_c("strong", [_vm._v("Site Privacy Policy  ")])]
              ),
            ]),
          ]
        ),
        _vm._v(" "),
        _c(
          "p",
          {
            staticStyle: {
              "margin-top": "0in",
              "margin-right": "0in",
              "margin-bottom": "12pt",
              "margin-left": "0in",
              "line-height": "19.2pt",
              "font-size": "15px",
              "font-family": "'Calibri', sans-serif",
              "text-align": "center",
            },
          },
          [
            _c("span", { staticStyle: { "font-size": "16px" } }, [
              _c(
                "span",
                { staticStyle: { "font-family": "Calibri, sans-serif" } },
                [
                  _vm._v(
                    "\n                    Version 1.21; Effective Date: Jun 10, 2020; Last revised on: June 8, 2020\n                "
                  ),
                ]
              ),
            ]),
          ]
        ),
        _vm._v(" "),
        _c(
          "ol",
          {
            staticStyle: {
              "list-style-type": "decimal",
              "margin-left": "-0.25in",
            },
          },
          [
            _c("li", [
              _c(
                "h1",
                {
                  staticStyle: {
                    "margin-top": "12pt",
                    "margin-right": "0in",
                    "margin-bottom": "0.0001pt",
                    "margin-left": "0.3in",
                    "text-indent": "-0.3in",
                    "line-height": "107%",
                    "font-size": "16px",
                    "font-family": "'Calibri Light', sans-serif",
                  },
                },
                [
                  _c("span", { staticStyle: { "font-size": "16px" } }, [
                    _c(
                      "span",
                      { staticStyle: { "font-family": "Calibri, sans-serif" } },
                      [_vm._v("Introduction.")]
                    ),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c("ol", { staticStyle: { "list-style-type": "lower-alpha" } }, [
                _c("li", [
                  _c("span", { staticStyle: { "font-size": "16px" } }, [
                    _c(
                      "span",
                      { staticStyle: { "font-family": "Calibri, sans-serif" } },
                      [
                        _vm._v(
                          "\n                                At Global Space Exchange, Inc. (“Global Space Exchange\n                                ”, “we ”, “our ”, or “us\n                                ”), your privacy is important to us and we understand that\n                                privacy is also important to you. Therefore, we have prepared\n                                this Privacy Policy to describe our practices regarding the\n                                types of Personal Data (as defined below) we collect from users\n                                of our website, located at https://www.globalspaceexchange.com/,\n                                our web application(s) (“Application ”), our\n                                widgets, and our online services (“Services ”)\n                                (collectively, the “Site ”). By using our Site, you\n                                consent to this Privacy Policy, including your consent to our\n                                use and disclosure of information about you in the manner\n                                described in this Privacy Policy.\n                            "
                        ),
                      ]
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("li", [
                  _c("span", { staticStyle: { "font-size": "16px" } }, [
                    _c(
                      "span",
                      { staticStyle: { "font-family": "Calibri, sans-serif" } },
                      [
                        _vm._v(
                          "\n                                Acceptance of Privacy Policy and Future Modifications\n                                (Amendments). By accessing or causing access to the Site and\n                                Services, you consent to this Privacy Policy, including your\n                                consent to our use and disclosure of information about you in\n                                the manner described in this Privacy Policy, as amended from\n                                time to time with or without notice to you. In addition, if you\n                                are using a particular service on this Site or accessed via this\n                                Site, you will be subject to any rules or guidelines applicable\n                                to those services, and they will be incorporated by reference\n                                within these Privacy Policy.\n                            "
                        ),
                      ]
                    ),
                  ]),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c("li", [
              _c(
                "h1",
                {
                  staticStyle: {
                    "margin-top": "12pt",
                    "margin-right": "0in",
                    "margin-bottom": "0.0001pt",
                    "margin-left": "0.3in",
                    "text-indent": "-0.3in",
                    "line-height": "107%",
                    "font-size": "16px",
                    "font-family": "'Calibri Light', sans-serif",
                  },
                },
                [
                  _c("span", { staticStyle: { "font-size": "16px" } }, [
                    _c(
                      "span",
                      { staticStyle: { "font-family": "Calibri, sans-serif" } },
                      [_vm._v("User Consent.")]
                    ),
                  ]),
                ]
              ),
            ]),
          ]
        ),
        _vm._v(" "),
        _c(
          "ol",
          {
            staticStyle: {
              "list-style-type": "lower-alpha",
              "margin-left": "0.5in",
            },
            attrs: { start: "1" },
          },
          [
            _c("li", [
              _c("span", { staticStyle: { "font-size": "16px" } }, [
                _c(
                  "span",
                  { staticStyle: { "font-family": "Calibri, sans-serif" } },
                  [
                    _vm._v(
                      "\n                        By submitting Personal Data through our Site or Services, you agree to\n                        the terms of this Privacy Policy and you expressly consent to the\n                        collection, use and disclosure of your Personal Data in accordance with\n                        this Privacy Policy.\n                    "
                    ),
                  ]
                ),
              ]),
            ]),
          ]
        ),
        _vm._v(" "),
        _c(
          "h1",
          {
            staticStyle: {
              "margin-top": "12pt",
              "margin-right": "0in",
              "margin-bottom": "0.0001pt",
              "margin-left": "0.3in",
              "text-indent": "-0.3in",
              "line-height": "107%",
              "font-size": "16px",
              "font-family": "'Calibri Light', sans-serif",
            },
          },
          [
            _c("span", { staticStyle: { "font-size": "16px" } }, [
              _c(
                "span",
                { staticStyle: { "font-family": "Calibri, sans-serif" } },
                [
                  _vm._v(
                    "\n                    3. A Note to Users Outside of the United States.\n                "
                  ),
                ]
              ),
            ]),
          ]
        ),
        _vm._v(" "),
        _c(
          "ol",
          {
            staticStyle: {
              "list-style-type": "lower-alpha",
              "margin-left": "0.5in",
            },
            attrs: { start: "1" },
          },
          [
            _c("li", [
              _c("span", { staticStyle: { "font-size": "16px" } }, [
                _c(
                  "span",
                  { staticStyle: { "font-family": "Calibri, sans-serif" } },
                  [
                    _vm._v(
                      "\n                        If you are a non-U.S. user of the Site, by visiting the Site and\n                        providing us with data, you acknowledge and agree that your Personal\n                        Data may be processed for the purposes identified in the Privacy Policy.\n                        In addition, your Personal Data may be processed in the country in which\n                        it was collected and in other countries, including the United States,\n                        where laws regarding processing of Personal Data may be less stringent\n                        than the laws in your country. By providing your Personal Data, you\n                        consent to such transfer. \n                    "
                    ),
                  ]
                ),
              ]),
            ]),
          ]
        ),
        _vm._v(" "),
        _c(
          "h1",
          {
            staticStyle: {
              "margin-top": "12pt",
              "margin-right": "0in",
              "margin-bottom": "0.0001pt",
              "margin-left": "0.3in",
              "text-indent": "-0.3in",
              "line-height": "107%",
              "font-size": "16px",
              "font-family": "'Calibri Light', sans-serif",
            },
          },
          [
            _c("span", { staticStyle: { "font-size": "16px" } }, [
              _c(
                "span",
                { staticStyle: { "font-family": "Calibri, sans-serif" } },
                [
                  _vm._v(
                    "\n                    4. Types of Data We Collect.\n                "
                  ),
                ]
              ),
            ]),
          ]
        ),
        _vm._v(" "),
        _c(
          "ol",
          {
            staticStyle: {
              "list-style-type": "lower-alpha",
              "margin-left": "0.5in",
            },
            attrs: { start: "1" },
          },
          [
            _c("li", [
              _c("span", { staticStyle: { "font-size": "16px" } }, [
                _c(
                  "span",
                  { staticStyle: { "font-family": "Calibri, sans-serif" } },
                  [
                    _vm._v(
                      "\n                        We collect Personal Data, Anonymous Data, and Publicly Available Data as\n                        described below for the provisioning of services. We do not respond to\n                        do not track signals and offer no ability to opt out of data collection\n                        other than as detailed below. Do not use the Site if you do not wish for\n                        us to collect Personal Data.\n                    "
                    ),
                  ]
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("li", [
              _c("span", { staticStyle: { "font-size": "16px" } }, [
                _c(
                  "span",
                  { staticStyle: { "font-family": "Calibri, sans-serif" } },
                  [
                    _vm._v(
                      "\n                        “Personal Data ”means data that allows someone to identify\n                        or contact you, including, for example, your name, address, telephone\n                        number, e-mail address, as well as any other non-public information\n                        about you that is associated with or linked to any of the foregoing\n                        data. For the purposes of this Privacy Policy, “Personal Data\n                        ”also includes Non-Public Information. “Anonymous Data\n                        ”means data that is not associated with or linked to your Personal\n                        Data; Anonymous Data does not, by itself, permit the identification of\n                        individual persons. “Publicly Available ”data means data\n                        that can be accessed by the general public and may or may not be\n                        anonymous.\n                    "
                    ),
                  ]
                ),
              ]),
              _vm._v(" "),
              _c("ol", { staticStyle: { "list-style-type": "lower-roman" } }, [
                _c("li", [
                  _c("span", { staticStyle: { "font-size": "16px" } }, [
                    _c(
                      "span",
                      { staticStyle: { "font-family": "Calibri, sans-serif" } },
                      [
                        _vm._v(
                          "\n                                Information You Provide to Us. We may collect the following\n                                data, which may include Personal Data, from you when you create\n                                an account to log in to our network (“Account\n                                ”): \n                            "
                        ),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "ol",
                    { staticStyle: { "list-style-type": "undefined" } },
                    [
                      _c("li", [
                        _c("span", { staticStyle: { "font-size": "16px" } }, [
                          _c(
                            "span",
                            {
                              staticStyle: {
                                "font-family": "Calibri, sans-serif",
                              },
                            },
                            [_vm._v("Name.")]
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("li", [
                        _c("span", { staticStyle: { "font-size": "16px" } }, [
                          _c(
                            "span",
                            {
                              staticStyle: {
                                "font-family": "Calibri, sans-serif",
                              },
                            },
                            [
                              _vm._v(
                                "\n                                        Physical Address.\n                                    "
                              ),
                            ]
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("li", [
                        _c("span", { staticStyle: { "font-size": "16px" } }, [
                          _c(
                            "span",
                            {
                              staticStyle: {
                                "font-family": "Calibri, sans-serif",
                              },
                            },
                            [
                              _vm._v(
                                "\n                                        Mailing Address.\n                                    "
                              ),
                            ]
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("li", [
                        _c("span", { staticStyle: { "font-size": "16px" } }, [
                          _c(
                            "span",
                            {
                              staticStyle: {
                                "font-family": "Calibri, sans-serif",
                              },
                            },
                            [
                              _vm._v(
                                "\n                                        Employer Identification Number (EIN).\n                                    "
                              ),
                            ]
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("li", [
                        _c("span", { staticStyle: { "font-size": "16px" } }, [
                          _c(
                            "span",
                            {
                              staticStyle: {
                                "font-family": "Calibri, sans-serif",
                              },
                            },
                            [
                              _vm._v(
                                "\n                                        Date of Birth.\n                                    "
                              ),
                            ]
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("li", [
                        _c("span", { staticStyle: { "font-size": "16px" } }, [
                          _c(
                            "span",
                            {
                              staticStyle: {
                                "font-family": "Calibri, sans-serif",
                              },
                            },
                            [
                              _vm._v(
                                "\n                                        Email Address.\n                                    "
                              ),
                            ]
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("li", [
                        _c("span", { staticStyle: { "font-size": "16px" } }, [
                          _c(
                            "span",
                            {
                              staticStyle: {
                                "font-family": "Calibri, sans-serif",
                              },
                            },
                            [
                              _vm._v(
                                "\n                                        Phone Number.\n                                    "
                              ),
                            ]
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("li", [
                        _c("span", { staticStyle: { "font-size": "16px" } }, [
                          _c(
                            "span",
                            {
                              staticStyle: {
                                "font-family": "Calibri, sans-serif",
                              },
                            },
                            [
                              _vm._v(
                                "\n                                        Personal credit card information.\n                                    "
                              ),
                            ]
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("li", [
                        _c("span", { staticStyle: { "font-size": "16px" } }, [
                          _c(
                            "span",
                            {
                              staticStyle: {
                                "font-family": "Calibri, sans-serif",
                              },
                            },
                            [
                              _vm._v(
                                "\n                                        Personal bank account information.\n                                    "
                              ),
                            ]
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("li", [
                        _c("span", { staticStyle: { "font-size": "16px" } }, [
                          _c(
                            "span",
                            {
                              staticStyle: {
                                "font-family": "Calibri, sans-serif",
                              },
                            },
                            [
                              _vm._v(
                                "\n                                        If you use our Services on your mobile device, including\n                                        through our Application, we may collect your phone\n                                        number and the unique device ID number.\n                                    "
                              ),
                            ]
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("li", [
                        _c("span", { staticStyle: { "font-size": "16px" } }, [
                          _c(
                            "span",
                            {
                              staticStyle: {
                                "font-family": "Calibri, sans-serif",
                              },
                            },
                            [
                              _vm._v(
                                "\n                                        If you tell us where you are (e.g., by allowing your\n                                        mobile device to send us your location), we may store\n                                        and use that information to provide you with\n                                        location-based information and advertising. If you want\n                                        to deactivate this feature, you can deactivate GPS or\n                                        location services on your mobile device.\n                                    "
                              ),
                            ]
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("li", [
                        _c("span", { staticStyle: { "font-size": "16px" } }, [
                          _c(
                            "span",
                            {
                              staticStyle: {
                                "font-family": "Calibri, sans-serif",
                              },
                            },
                            [
                              _vm._v(
                                "\n                                        Our Site may let you store preferences like how your\n                                        content is displayed, your location, safe search\n                                        settings, and favorite widgets. We may associate these\n                                        choices with your ID, browser or the mobile device, and\n                                        you can edit these preferences at any time, once they\n                                        have been made available.\n                                    "
                              ),
                            ]
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("li", [
                        _c("span", { staticStyle: { "font-size": "16px" } }, [
                          _c(
                            "span",
                            {
                              staticStyle: {
                                "font-family": "Calibri, sans-serif",
                              },
                            },
                            [
                              _vm._v(
                                "\n                                        When connecting to our Services via a service provider\n                                        that uniquely identifies your mobile device, we may\n                                        receive this identification and use it to offer extended\n                                        services and/or functionality.\n                                    "
                              ),
                            ]
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("li", [
                        _c("span", { staticStyle: { "font-size": "16px" } }, [
                          _c(
                            "span",
                            {
                              staticStyle: {
                                "font-family": "Calibri, sans-serif",
                              },
                            },
                            [
                              _vm._v(
                                "\n                                        Certain Services, such as two-factor authentication, may\n                                        require our collection of your phone number. We may\n                                        associate that phone number to your mobile device\n                                        identification information.\n                                    "
                              ),
                            ]
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("li", [
                        _c("span", { staticStyle: { "font-size": "16px" } }, [
                          _c(
                            "span",
                            {
                              staticStyle: {
                                "font-family": "Calibri, sans-serif",
                              },
                            },
                            [
                              _vm._v(
                                "\n                                        We retain information on your behalf, such as files and\n                                        messages that you store using your Account.\n                                    "
                              ),
                            ]
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("li", [
                        _c("span", { staticStyle: { "font-size": "16px" } }, [
                          _c(
                            "span",
                            {
                              staticStyle: {
                                "font-family": "Calibri, sans-serif",
                              },
                            },
                            [
                              _vm._v(
                                "\n                                        If you provide us with feedback or contact us via\n                                        e-mail, we will collect your name and e-mail address, as\n                                        well as any other content included in the e-mail, to\n                                        send you a reply.\n                                    "
                              ),
                            ]
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("li", [
                        _c("span", { staticStyle: { "font-size": "16px" } }, [
                          _c(
                            "span",
                            {
                              staticStyle: {
                                "font-family": "Calibri, sans-serif",
                              },
                            },
                            [
                              _vm._v(
                                "\n                                        When you post messages on the message boards or events\n                                        to the calendars of our Site, the information contained\n                                        in your posting will be stored on our servers and other\n                                        users will be able to see it.\n                                    "
                              ),
                            ]
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("li", [
                        _c("span", { staticStyle: { "font-size": "16px" } }, [
                          _c(
                            "span",
                            {
                              staticStyle: {
                                "font-family": "Calibri, sans-serif",
                              },
                            },
                            [
                              _vm._v(
                                "\n                                        When you participate in one of our surveys, we may\n                                        collect additional profile information.\n                                    "
                              ),
                            ]
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("li", [
                        _c("span", { staticStyle: { "font-size": "16px" } }, [
                          _c(
                            "span",
                            {
                              staticStyle: {
                                "font-family": "Calibri, sans-serif",
                              },
                            },
                            [
                              _vm._v(
                                "\n                                        When you provide feedback, we will collect identifying\n                                        information in the case that we need to contact you.\n                                    "
                              ),
                            ]
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("li", [
                        _c("span", { staticStyle: { "font-size": "16px" } }, [
                          _c(
                            "span",
                            {
                              staticStyle: {
                                "font-family": "Calibri, sans-serif",
                              },
                            },
                            [
                              _vm._v(
                                "\n                                        We also collect other types of Personal Data that you\n                                        provide to us voluntarily, such as your operating system\n                                        and version, product registration number, and other\n                                        requested information if you contact us via e-mail\n                                        regarding support for the Services.\n                                    "
                              ),
                            ]
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("li", [
                        _c("span", { staticStyle: { "font-size": "16px" } }, [
                          _c(
                            "span",
                            {
                              staticStyle: {
                                "font-family": "Calibri, sans-serif",
                              },
                            },
                            [
                              _vm._v(
                                "\n                                        We may also collect Personal Data at other points in our\n                                        Site that state that Personal Data is being collected.\n                                    "
                              ),
                            ]
                          ),
                        ]),
                      ]),
                    ]
                  ),
                ]),
                _vm._v(" "),
                _c("li", [
                  _c("span", { staticStyle: { "font-size": "16px" } }, [
                    _c(
                      "span",
                      { staticStyle: { "font-family": "Calibri, sans-serif" } },
                      [
                        _vm._v(
                          "\n                                Information Collected via Technology\n                            "
                        ),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "ol",
                    { staticStyle: { "list-style-type": "undefined" } },
                    [
                      _c("li", [
                        _c("span", { staticStyle: { "font-size": "16px" } }, [
                          _c(
                            "span",
                            {
                              staticStyle: {
                                "font-family": "Calibri, sans-serif",
                              },
                            },
                            [
                              _vm._v(
                                "\n                                        Information Collected by Our Servers. To make our Site\n                                        and Services more useful to you, our servers (which may\n                                        be hosted by a third party service provider) collect\n                                        information from you, including your browser type,\n                                        operating system, Internet Protocol (“IP ”)\n                                        address (a number that is automatically assigned to your\n                                        computer when you use the Internet, which may vary from\n                                        session to session), domain name, and/or a date/time\n                                        stamp for your visit.\n                                    "
                              ),
                            ]
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("li", [
                        _c("span", { staticStyle: { "font-size": "16px" } }, [
                          _c(
                            "span",
                            {
                              staticStyle: {
                                "font-family": "Calibri, sans-serif",
                              },
                            },
                            [
                              _vm._v(
                                "\n                                        Log Files. As is true of most websites, we gather\n                                        certain information automatically and store it in log\n                                        files.  This information includes IP addresses,\n                                        browser type, Internet service provider (“ISP\n                                        ”), referring/exit pages, operating system,\n                                        date/time stamp, and clickstream data.  We use this\n                                        information to analyze trends, administer the Site,\n                                        track users ’movements around the Site, gather\n                                        demographic information about our user base as a whole,\n                                        and better tailor our Services to our users\n                                        ’needs.  For example, some of the information\n                                        may be collected so that future versions of the site are\n                                        designed to be more useful based upon how often certain\n                                        features are utilized.  Except as noted in this\n                                        Privacy Policy, we do not link this\n                                        automatically-collected data to Personal Data.\n                                    "
                              ),
                            ]
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("li", [
                        _c("span", { staticStyle: { "font-size": "16px" } }, [
                          _c(
                            "span",
                            {
                              staticStyle: {
                                "font-family": "Calibri, sans-serif",
                              },
                            },
                            [
                              _vm._v(
                                "\n                                        Cookies. Like many online services, we use cookies to\n                                        collect information.  “Cookies ”are\n                                        small pieces of information that a website sends to your\n                                        computer hard drive while you are viewing the website.\n                                        We may use both session Cookies (which expire once you\n                                        close your web browser) and persistent Cookies (which\n                                        stay on your computer until you delete them) to provide\n                                        you with a more personal and interactive experience on\n                                        our Site. This type of information is collected to make\n                                        the Site more useful to you and to tailor the experience\n                                        with us to meet your special interests and needs.\n                                    "
                              ),
                            ]
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("li", [
                        _c("span", { staticStyle: { "font-size": "16px" } }, [
                          _c(
                            "span",
                            {
                              staticStyle: {
                                "font-family": "Calibri, sans-serif",
                              },
                            },
                            [
                              _vm._v(
                                "\n                                        Pixel Tags. We may use “Pixel Tags ”(also\n                                        referred to as clear Gifs, Web beacons, or Web bugs).\n                                        Pixel Tags are tiny graphic images with a unique\n                                        identifier, similar in function to Cookies, that are\n                                        used to track online movements of Web users. In contrast\n                                        to Cookies, which are stored on a user ’s computer\n                                        hard drive, Pixel Tags are embedded invisibly in Web\n                                        pages. Pixel Tags also allow us to send e-mail messages\n                                        in a format that users can read, and they tell us\n                                        whether e-mails have been opened to ensure that we are\n                                        sending only messages that are of interest to our users.\n                                        We may use this information to reduce or eliminate\n                                        messages sent to a user. We do not tie the information\n                                        gathered by Pixel Tags to our users ’Personal\n                                        Data.\n                                    "
                              ),
                            ]
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("li", [
                        _c("span", { staticStyle: { "font-size": "16px" } }, [
                          _c(
                            "span",
                            {
                              staticStyle: {
                                "font-family": "Calibri, sans-serif",
                              },
                            },
                            [
                              _vm._v(
                                "\n                                        Collection of Data by Advertisers. We may also use third\n                                        parties to serve ads on the Site. Certain third parties\n                                        may automatically collect information about your visits\n                                        to this and other websites, your IP address, your ISP,\n                                        the browser you use to visit our Site (but not your\n                                        name, address, e-mail address or telephone number). They\n                                        do this by using Cookies, Pixel Tags, or other\n                                        technologies.  Information collected may be used,\n                                        among other things, to deliver advertising targeted to\n                                        your interests and to better understand the usage and\n                                        visitation of our Site and the other sites tracked by\n                                        these third parties. This policy does not apply to, and\n                                        we are not responsible for, Cookies or Pixel Tags in\n                                        third party ads, and we encourage you to check the\n                                        privacy policies of advertisers and/or ad services to\n                                        learn about their use of Cookies and other technologies.\n                                        You may opt out of receiving interest-based advertising\n                                        from some of our partners by emailing\n                                        support@globalspaceexchange.com. If you would like more\n                                        information about this practice and to know your choices\n                                        about not having this information used by these\n                                        companies, click here: http://www.aboutads.info/choices\n                                        or http://www.networkadvertising.org.\n                                    "
                              ),
                            ]
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("li", [
                        _c("span", { staticStyle: { "font-size": "16px" } }, [
                          _c(
                            "span",
                            {
                              staticStyle: {
                                "font-family": "Calibri, sans-serif",
                              },
                            },
                            [
                              _vm._v(
                                "\n                                        Mobile Services. We may also collect non-Personal Data\n                                        from your mobile device. This information is generally\n                                        used to help us deliver the most relevant information to\n                                        you. Examples of information that may be collected and\n                                        used include your geographic location, how you use the\n                                        Site and Services, and information about the type of\n                                        device you use. This information is sent to us as\n                                        aggregated information and is not traceable to any\n                                        individual and cannot be used to identify an individual.\n                                    "
                              ),
                            ]
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("li", [
                        _c("span", { staticStyle: { "font-size": "16px" } }, [
                          _c(
                            "span",
                            {
                              staticStyle: {
                                "font-family": "Calibri, sans-serif",
                              },
                            },
                            [
                              _vm._v(
                                "\n                                        Analytics Services and Interest-Based Advertising. In\n                                        addition to the tracking technologies we place, other\n                                        companies may set their own cookies or similar tools\n                                        when you visit our Site. This includes third party\n                                        analytics services, including but not limited to Google\n                                        Analytics (“Analytics Services ”), that we\n                                        engage to help analyze how users use the Site, as well\n                                        as third parties that deliver content or offers. We may\n                                        receive reports based on these parties ’use of\n                                        these tools on an individual or aggregate basis. We use\n                                        the information we get from Analytics Services only to\n                                        improve our Site and Services. The information generated\n                                        by the Cookies or other technologies about your use of\n                                        our Site and Services (the “Analytics Information\n                                        ”) is transmitted to the Analytics Services. The\n                                        Analytics Services use Analytics Information to compile\n                                        reports on user activity. The Analytics Services may\n                                        also transfer information to third parties where\n                                        required to do so by law, or where such third parties\n                                        process Analytics Information on their behalf. Each\n                                        Analytics Services ’ability to use and share\n                                        Analytics Information is restricted by such Analytics\n                                        Services ’Terms of Use and Privacy Policy. By\n                                        using our Site and Services, you consent to the\n                                        processing of data about you by Analytics Services in\n                                        the manner and for the purposes set out above. For a\n                                        full list of Analytics Services, please contact us at\n                                        support@globalspaceexchange.com. We may also partner\n                                        with ad companies to support our marketing efforts,\n                                        including by serving you ads better tailored to your\n                                        likely interests. If you don ’t want to take\n                                        advantage of these services, you may be able to opt-out\n                                        by visiting http://www.aboutads.info/ or\n                                        http://networkadvertising.org/choices/, or if you are\n                                        located in the EU, http://www.youronlinechoices.eu/.\n                                    "
                              ),
                            ]
                          ),
                        ]),
                      ]),
                    ]
                  ),
                ]),
                _vm._v(" "),
                _c("li", [
                  _c("span", { staticStyle: { "font-size": "16px" } }, [
                    _c(
                      "span",
                      { staticStyle: { "font-family": "Calibri, sans-serif" } },
                      [
                        _vm._v(
                          "\n                                Information Collected from Third Party Companies.\n                            "
                        ),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "ol",
                    { staticStyle: { "list-style-type": "undefined" } },
                    [
                      _c("li", [
                        _c("span", { staticStyle: { "font-size": "16px" } }, [
                          _c(
                            "span",
                            {
                              staticStyle: {
                                "font-family": "Calibri, sans-serif",
                              },
                            },
                            [
                              _vm._v(
                                "\n                                        We may receive Personal and/or Anonymous Data about you\n                                        from companies that provide our Services by way of a\n                                        co-branded or private-labeled website or companies that\n                                        offer their products and/or services on our Site. These\n                                        third-party companies may supply us with Personal Data.\n                                        We may add this information to the information we have\n                                        already collected from you via our Site in order to\n                                        improve the Services we provide.\n                                    "
                              ),
                            ]
                          ),
                        ]),
                      ]),
                    ]
                  ),
                ]),
                _vm._v(" "),
                _c("li", [
                  _c("span", { staticStyle: { "font-size": "16px" } }, [
                    _c(
                      "span",
                      { staticStyle: { "font-family": "Calibri, sans-serif" } },
                      [
                        _vm._v(
                          "\n                                Information Collected from Employers.\n                            "
                        ),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "ol",
                    { staticStyle: { "list-style-type": "undefined" } },
                    [
                      _c("li", [
                        _c("span", { staticStyle: { "font-size": "16px" } }, [
                          _c(
                            "span",
                            {
                              staticStyle: {
                                "font-family": "Calibri, sans-serif",
                              },
                            },
                            [
                              _vm._v(
                                "\n                                        If your Account was established by your employer, they\n                                        may have provided some personal information. We may\n                                        store and utilize that information in order to provide\n                                        service to those users and associated employers.\n                                    "
                              ),
                            ]
                          ),
                        ]),
                      ]),
                    ]
                  ),
                ]),
                _vm._v(" "),
                _c("li", [
                  _c("span", { staticStyle: { "font-size": "16px" } }, [
                    _c(
                      "span",
                      { staticStyle: { "font-family": "Calibri, sans-serif" } },
                      [_vm._v("Location.")]
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "ol",
                    { staticStyle: { "list-style-type": "undefined" } },
                    [
                      _c("li", [
                        _c("span", { staticStyle: { "font-size": "16px" } }, [
                          _c(
                            "span",
                            {
                              staticStyle: {
                                "font-family": "Calibri, sans-serif",
                              },
                            },
                            [
                              _vm._v(
                                "\n                                        When you use our Site and Services, we may collect and\n                                        process location information.  If you do not want\n                                        this information collected by us, you can disable\n                                        location services on your device.\n                                    "
                              ),
                            ]
                          ),
                        ]),
                      ]),
                    ]
                  ),
                ]),
                _vm._v(" "),
                _c("li", [
                  _c("span", { staticStyle: { "font-size": "16px" } }, [
                    _c(
                      "span",
                      { staticStyle: { "font-family": "Calibri, sans-serif" } },
                      [
                        _vm._v(
                          "\n                                Information Collected from Publicly Available Sources.\n                            "
                        ),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "ol",
                    { staticStyle: { "list-style-type": "undefined" } },
                    [
                      _c("li", [
                        _c("span", { staticStyle: { "font-size": "16px" } }, [
                          _c(
                            "span",
                            {
                              staticStyle: {
                                "font-family": "Calibri, sans-serif",
                              },
                            },
                            [
                              _vm._v(
                                "\n                                        We may utilize data collected from publicly available\n                                        sources, for example, the world wide web, government\n                                        sources, and commercial sources.  The data may or\n                                        may not be anonymous and may be associated or compiled\n                                        with other data we have collected.\n                                    "
                              ),
                            ]
                          ),
                        ]),
                      ]),
                    ]
                  ),
                ]),
              ]),
            ]),
          ]
        ),
        _vm._v(" "),
        _c(
          "h1",
          {
            staticStyle: {
              "margin-top": "12pt",
              "margin-right": "0in",
              "margin-bottom": "0.0001pt",
              "margin-left": "0.3in",
              "text-indent": "-0.3in",
              "line-height": "107%",
              "font-size": "16px",
              "font-family": "'Calibri Light', sans-serif",
            },
          },
          [
            _c("span", { staticStyle: { "font-size": "16px" } }, [
              _c(
                "span",
                { staticStyle: { "font-family": "Calibri, sans-serif" } },
                [
                  _vm._v(
                    "\n                    5. Use of Your Personal Data.\n                "
                  ),
                ]
              ),
            ]),
          ]
        ),
        _vm._v(" "),
        _c(
          "ol",
          {
            staticStyle: {
              "list-style-type": "lower-alpha",
              "margin-left": "0.5in",
            },
            attrs: { start: "1" },
          },
          [
            _c("li", [
              _c("span", { staticStyle: { "font-size": "16px" } }, [
                _c(
                  "span",
                  { staticStyle: { "font-family": "Calibri, sans-serif" } },
                  [
                    _vm._v(
                      "\n                        General Use. We use and retain your Personal Data in order to provide\n                        products and services and may, from time to time, provide such\n                        information to nonaffiliated third-party service providers to perform\n                        services for or functions on behalf of us, to effect, administer, or\n                        enforce transactions authorized by you; for example,\n                    "
                    ),
                  ]
                ),
              ]),
            ]),
          ]
        ),
        _vm._v(" "),
        _c(
          "ol",
          {
            staticStyle: {
              "list-style-type": "lower-roman",
              "margin-left": "107px",
            },
          },
          [
            _c("li", [
              _c("span", { staticStyle: { "font-size": "16px" } }, [
                _c(
                  "span",
                  { staticStyle: { "font-family": "Calibri, sans-serif" } },
                  [
                    _vm._v(
                      "\n                        To verify your identity to open and administer your Accounts; \n                    "
                    ),
                  ]
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("li", [
              _c("span", { staticStyle: { "font-size": "16px" } }, [
                _c(
                  "span",
                  { staticStyle: { "font-family": "Calibri, sans-serif" } },
                  [
                    _vm._v(
                      "\n                        To provide financial services related to the facilitation of\n                        transactions;\n                    "
                    ),
                  ]
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("li", [
              _c("span", { staticStyle: { "font-size": "16px" } }, [
                _c(
                  "span",
                  { staticStyle: { "font-family": "Calibri, sans-serif" } },
                  [_vm._v("To process payments;")]
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("li", [
              _c("span", { staticStyle: { "font-size": "16px" } }, [
                _c(
                  "span",
                  { staticStyle: { "font-family": "Calibri, sans-serif" } },
                  [
                    _vm._v(
                      "\n                        To help us protect you and us from financial loss;\n                    "
                    ),
                  ]
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("li", [
              _c("span", { staticStyle: { "font-size": "16px" } }, [
                _c(
                  "span",
                  { staticStyle: { "font-family": "Calibri, sans-serif" } },
                  [
                    _vm._v(
                      "\n                        To prepare account statements; and\n                    "
                    ),
                  ]
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("li", [
              _c("span", { staticStyle: { "font-size": "16px" } }, [
                _c(
                  "span",
                  { staticStyle: { "font-family": "Calibri, sans-serif" } },
                  [
                    _vm._v(
                      "\n                        To prepare annual tax reporting information, if applicable.\n                    "
                    ),
                  ]
                ),
              ]),
            ]),
          ]
        ),
        _vm._v(" "),
        _c(
          "ol",
          {
            staticStyle: {
              "list-style-type": "lower-alpha",
              "margin-left": "0.5in",
            },
            attrs: { start: "2" },
          },
          [
            _c("li", [
              _c("span", { staticStyle: { "font-size": "16px" } }, [
                _c(
                  "span",
                  { staticStyle: { "font-family": "Calibri, sans-serif" } },
                  [
                    _vm._v(
                      "\n                        In addition, we will collect and store the following:\n                    "
                    ),
                  ]
                ),
              ]),
            ]),
          ]
        ),
        _vm._v(" "),
        _c(
          "ol",
          {
            staticStyle: {
              "list-style-type": "lower-roman",
              "margin-left": "107px",
            },
          },
          [
            _c("li", [
              _c("span", { staticStyle: { "font-size": "16px" } }, [
                _c(
                  "span",
                  { staticStyle: { "font-family": "Calibri, sans-serif" } },
                  [
                    _vm._v(
                      "\n                        Names and other identifying information of people authorized by you to\n                        use corporate Accounts as described in your license;\n                    "
                    ),
                  ]
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("li", [
              _c("span", { staticStyle: { "font-size": "16px" } }, [
                _c(
                  "span",
                  { staticStyle: { "font-family": "Calibri, sans-serif" } },
                  [
                    _vm._v(
                      "\n                        Names and other identifying information of people authorized by you to\n                        access Corporate Accounts, where Corporate Accounts are those associated\n                        with or inclusive of a corporate profile or other organizational\n                        information; and\n                    "
                    ),
                  ]
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("li", [
              _c("span", { staticStyle: { "font-size": "16px" } }, [
                _c(
                  "span",
                  { staticStyle: { "font-family": "Calibri, sans-serif" } },
                  [
                    _vm._v(
                      "\n                        Transactions with us such as your fees, payments, withdrawals, and the\n                        identity of persons to whom you make payments.\n                    "
                    ),
                  ]
                ),
              ]),
            ]),
          ]
        ),
        _vm._v(" "),
        _c(
          "ol",
          {
            staticStyle: {
              "list-style-type": "lower-alpha",
              "margin-left": "0.5in",
            },
            attrs: { start: "3" },
          },
          [
            _c("li", [
              _c("span", { staticStyle: { "font-size": "16px" } }, [
                _c(
                  "span",
                  { staticStyle: { "font-family": "Calibri, sans-serif" } },
                  [
                    _vm._v(
                      "\n                         User Testimonials and Feedback. \n                    "
                    ),
                  ]
                ),
              ]),
            ]),
          ]
        ),
        _vm._v(" "),
        _c(
          "ol",
          {
            staticStyle: {
              "list-style-type": "lower-roman",
              "margin-left": "107px",
            },
          },
          [
            _c("li", [
              _c("span", { staticStyle: { "font-size": "16px" } }, [
                _c(
                  "span",
                  { staticStyle: { "font-family": "Calibri, sans-serif" } },
                  [
                    _vm._v(
                      "\n                        We often receive testimonials and comments from users who have had\n                        positive experiences with our Services. We occasionally publish such\n                        content. When we publish this content, we may identify our users by\n                        their first and last name and may also indicate their home city. We\n                        obtain the user ’s consent prior to posting his or her name along\n                        with the testimonial. We may post user feedback on the Site from time to\n                        time. We will share your feedback with your first name and last initial\n                        only. If we choose to post your first and last name along with your\n                        feedback, we will obtain your consent prior to posting you name with\n                        your feedback. If you make any comments on a blog or forum associated\n                        with our Site, you should be aware that any Personal Data you submit\n                        there can be read, collected, or used by other users of these forums,\n                        and could be used to send you unsolicited messages. We are not\n                        responsible for the personally identifiable information you choose to\n                        submit in these blogs and forums.\n                    "
                    ),
                  ]
                ),
              ]),
            ]),
          ]
        ),
        _vm._v(" "),
        _c(
          "ol",
          {
            staticStyle: {
              "list-style-type": "lower-alpha",
              "margin-left": "0.5in",
            },
            attrs: { start: "4" },
          },
          [
            _c("li", [
              _c("span", { staticStyle: { "font-size": "16px" } }, [
                _c(
                  "span",
                  { staticStyle: { "font-family": "Calibri, sans-serif" } },
                  [
                    _vm._v(
                      "\n                        Creation of Anonymous Data. \n                    "
                    ),
                  ]
                ),
              ]),
            ]),
          ]
        ),
        _vm._v(" "),
        _c(
          "ol",
          {
            staticStyle: {
              "list-style-type": "lower-roman",
              "margin-left": "107px",
            },
          },
          [
            _c("li", [
              _c("span", { staticStyle: { "font-size": "16px" } }, [
                _c(
                  "span",
                  { staticStyle: { "font-family": "Calibri, sans-serif" } },
                  [
                    _vm._v(
                      "\n                        We may create Anonymous Data records from Personal Data by excluding\n                        information (such as your name) that makes the data personally\n                        identifiable to you. We use this Anonymous Data to analyze request and\n                        usage patterns so that we may enhance the content of our Services and\n                        improve Site navigation. We reserve the right to use Anonymous Data and\n                        aggregated and other de-identified information for any purpose and\n                        disclose Anonymous Data to third parties in our sole discretion.\n                    "
                    ),
                  ]
                ),
              ]),
            ]),
          ]
        ),
        _vm._v(" "),
        _c(
          "h1",
          {
            staticStyle: {
              "margin-top": "12pt",
              "margin-right": "0in",
              "margin-bottom": "0.0001pt",
              "margin-left": "0.3in",
              "text-indent": "-0.3in",
              "line-height": "107%",
              "font-size": "16px",
              "font-family": "'Calibri Light', sans-serif",
            },
          },
          [
            _c("span", { staticStyle: { "font-size": "16px" } }, [
              _c(
                "span",
                { staticStyle: { "font-family": "Calibri, sans-serif" } },
                [
                  _vm._v(
                    "\n                    6. Financial Institution Data.  \n                "
                  ),
                ]
              ),
            ]),
          ]
        ),
        _vm._v(" "),
        _c(
          "ol",
          {
            staticStyle: {
              "list-style-type": "lower-alpha",
              "margin-left": "0.5in",
            },
            attrs: { start: "1" },
          },
          [
            _c("li", [
              _c("span", { staticStyle: { "font-size": "16px" } }, [
                _c(
                  "span",
                  { staticStyle: { "font-family": "Calibri, sans-serif" } },
                  [
                    _vm._v(
                      "\n                        Global Space Exchange uses Stripe, Inc. (“Stripe ”) to\n                        conduct financial transactions. By using our service, you grant Global\n                        Space Exchange and Stripe the right, power, and authority to act on your\n                        behalf to access and transmit your personal and financial information\n                        from the relevant financial institution. You agree to your personal and\n                        financial information being transferred, stored, and processed by Stripe\n                        in accordance with the Stripe, Inc. Privacy Policy\n                        https://stripe.com/privacy. \n                    "
                    ),
                  ]
                ),
              ]),
            ]),
          ]
        ),
        _vm._v(" "),
        _c(
          "h1",
          {
            staticStyle: {
              "margin-top": "12pt",
              "margin-right": "0in",
              "margin-bottom": "0.0001pt",
              "margin-left": "0.3in",
              "text-indent": "-0.3in",
              "line-height": "107%",
              "font-size": "16px",
              "font-family": "'Calibri Light', sans-serif",
            },
          },
          [
            _c("span", { staticStyle: { "font-size": "16px" } }, [
              _c(
                "span",
                { staticStyle: { "font-family": "Calibri, sans-serif" } },
                [
                  _vm._v(
                    "\n                    7. Disclosure of Your Personal Data.\n                "
                  ),
                ]
              ),
            ]),
          ]
        ),
        _vm._v(" "),
        _c(
          "ol",
          {
            staticStyle: {
              "list-style-type": "lower-alpha",
              "margin-left": "0.5in",
            },
            attrs: { start: "1" },
          },
          [
            _c("li", [
              _c("span", { staticStyle: { "font-size": "16px" } }, [
                _c(
                  "span",
                  { staticStyle: { "font-family": "Calibri, sans-serif" } },
                  [
                    _vm._v(
                      "\n                        We disclose your Personal Data as described below and as described\n                        elsewhere in this Privacy Policy.\n                    "
                    ),
                  ]
                ),
              ]),
            ]),
          ]
        ),
        _vm._v(" "),
        _c(
          "ol",
          {
            staticStyle: {
              "list-style-type": "lower-roman",
              "margin-left": "107px",
            },
          },
          [
            _c("li", [
              _c("span", { staticStyle: { "font-size": "16px" } }, [
                _c(
                  "span",
                  { staticStyle: { "font-family": "Calibri, sans-serif" } },
                  [
                    _vm._v(
                      "\n                        Third Parties Designated by You. When you use the Services, the Personal\n                        Data you provide will be shared with third parties that you or your\n                        employer designate to receive such information. Depending on the type of\n                        access you or your employer grant to such third parties, they may also\n                        be permitted to edit the information you have provided to us and to\n                        designate others to access and edit such information. You may change\n                        your settings at any time as to who has access to your information by\n                        contacting us at support@globalspaceexchange.com. We will use\n                        commercially reasonable efforts to honor your requests.\n                    "
                    ),
                  ]
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("li", [
              _c("span", { staticStyle: { "font-size": "16px" } }, [
                _c(
                  "span",
                  { staticStyle: { "font-family": "Calibri, sans-serif" } },
                  [
                    _vm._v(
                      "\n                        Employers. We will share your Personal Data with your employer solely\n                        for the purpose of providing the Services and only when required to\n                        provide you service.\n                    "
                    ),
                  ]
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("li", [
              _c("span", { staticStyle: { "font-size": "16px" } }, [
                _c(
                  "span",
                  { staticStyle: { "font-family": "Calibri, sans-serif" } },
                  [
                    _vm._v(
                      "\n                        Third Party Service Providers. We may share your Personal Data with\n                        third party service providers, including reputable reference sources or\n                        reporting agencies, to:  provide you with the Services that we\n                        offer you through our Site; to conduct quality assurance testing; to\n                        facilitate creation of accounts; to provide technical support; for risk\n                        management and to maximize the accuracy of your information; and/or to\n                        provide other services to Global Space Exchange. These third-party\n                        service providers are required not to use your Personal Data other than\n                        to provide the services requested by Global Space Exchange.\n                    "
                    ),
                  ]
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("li", [
              _c("span", { staticStyle: { "font-size": "16px" } }, [
                _c(
                  "span",
                  { staticStyle: { "font-family": "Calibri, sans-serif" } },
                  [
                    _vm._v(
                      "\n                        Affiliates. We may share some or all of your Personal Data with our\n                        parent company, subsidiaries, joint ventures, or other companies under a\n                        common control (“Affiliates ”), in which case we will\n                        require our Affiliates to honor this Privacy Policy.\n                    "
                    ),
                  ]
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("li", [
              _c("span", { staticStyle: { "font-size": "16px" } }, [
                _c(
                  "span",
                  { staticStyle: { "font-family": "Calibri, sans-serif" } },
                  [
                    _vm._v(
                      "\n                        Corporate Restructuring. We may share some or all of your Personal Data\n                        in connection with or during negotiation of any merger, financing,\n                        acquisition or dissolution transaction or proceeding involving sale,\n                        transfer, divestiture, or disclosure of all or a portion of our business\n                        or assets.  In the event of an insolvency, bankruptcy, or\n                        receivership, Personal Data may also be transferred as a business asset.\n                        If another company acquires our company, business, or assets, that\n                        Global Space Exchange will possess the Personal Data collected by us and\n                        will assume the rights and obligations regarding your Personal Data as\n                        described in this Privacy Policy.\n                    "
                    ),
                  ]
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("li", [
              _c("span", { staticStyle: { "font-size": "16px" } }, [
                _c(
                  "span",
                  { staticStyle: { "font-family": "Calibri, sans-serif" } },
                  [
                    _vm._v(
                      "\n                        Disclosure to Third Party Companies. We may enter into agreements with\n                        companies that provide our Services by way of a co-branded or\n                        private-labeled website or companies or organizations that offer their\n                        products and/or services on our website (“Third Party ”or\n                        “Third Parties ”). Third Parties may want access to Personal\n                        Data that we collect from their customers. As a result, we may disclose\n                        your Personal Data to a Third Party; however, we will not disclose your\n                        Personal Data to any Third Party for the Third Party ’s own direct\n                        marketing purposes. The privacy policies of Third Party organizations\n                        may apply to the use and disclosure of your Personal Data that we\n                        collect and disclose to such Third Parties. Because we do not control\n                        the privacy practices of Third Parties, you should read and understand\n                        their privacy policies.\n                    "
                    ),
                  ]
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("li", [
              _c("span", { staticStyle: { "font-size": "16px" } }, [
                _c(
                  "span",
                  { staticStyle: { "font-family": "Calibri, sans-serif" } },
                  [
                    _vm._v(
                      "\n                        Other Disclosures. Regardless of any choices you make regarding your\n                        Personal Data (as described below), Global Space Exchange may disclose\n                        Personal Data if it believes in good faith that such disclosure is\n                        necessary (a) in connection with any legal investigation; (b) to comply\n                        with relevant laws or to respond to subpoenas or warrants served on\n                        Global Space Exchange; (c) to protect or defend the rights or property\n                        of Global Space Exchange or users of the Site or Services; and/or (d) to\n                        investigate or assist in preventing any violation or potential violation\n                        of the law, this Privacy Policy, or our Terms of Use.\n                    "
                    ),
                  ]
                ),
              ]),
            ]),
          ]
        ),
        _vm._v(" "),
        _c(
          "h1",
          {
            staticStyle: {
              "margin-top": "12pt",
              "margin-right": "0in",
              "margin-bottom": "0.0001pt",
              "margin-left": "0.3in",
              "text-indent": "-0.3in",
              "line-height": "107%",
              "font-size": "16px",
              "font-family": "'Calibri Light', sans-serif",
            },
          },
          [
            _c("span", { staticStyle: { "font-size": "16px" } }, [
              _c(
                "span",
                { staticStyle: { "font-family": "Calibri, sans-serif" } },
                [_vm._v("8. Third Party Websites.")]
              ),
            ]),
          ]
        ),
        _vm._v(" "),
        _c(
          "ol",
          {
            staticStyle: {
              "list-style-type": "lower-alpha",
              "margin-left": "0.5in",
            },
            attrs: { start: "1" },
          },
          [
            _c("li", [
              _c("span", { staticStyle: { "font-size": "16px" } }, [
                _c(
                  "span",
                  { staticStyle: { "font-family": "Calibri, sans-serif" } },
                  [
                    _vm._v(
                      "\n                        Our Site may contain links to third party websites. When you click on a\n                        link to any other website or location, you will leave our Site and go to\n                        another site, and another entity may collect Personal Data or Anonymous\n                        Data from you. We have no control over, do not review, and cannot be\n                        responsible for, these outside websites or their content. Please be\n                        aware that the terms of this Privacy Policy do not apply to these\n                        outside websites or content, or to any collection of your Personal Data\n                        after you click on links to such outside websites. We encourage you to\n                        read the privacy policies of every website you visit. The links to third\n                        party websites or locations are for your convenience and do not signify\n                        our endorsement of such third parties or their products, content or\n                        websites. \n                    "
                    ),
                  ]
                ),
              ]),
            ]),
          ]
        ),
        _vm._v(" "),
        _c(
          "h1",
          {
            staticStyle: {
              "margin-top": "12pt",
              "margin-right": "0in",
              "margin-bottom": "0.0001pt",
              "margin-left": "0.3in",
              "text-indent": "-0.3in",
              "line-height": "107%",
              "font-size": "16px",
              "font-family": "'Calibri Light', sans-serif",
            },
          },
          [
            _c("span", { staticStyle: { "font-size": "16px" } }, [
              _c(
                "span",
                { staticStyle: { "font-family": "Calibri, sans-serif" } },
                [
                  _vm._v(
                    "\n                    9. Your Choices Regarding Information.  \n                "
                  ),
                ]
              ),
            ]),
          ]
        ),
        _vm._v(" "),
        _c(
          "ol",
          {
            staticStyle: {
              "list-style-type": "lower-alpha",
              "margin-left": "0.25in",
            },
            attrs: { start: "1" },
          },
          [
            _c("li", [
              _c("span", { staticStyle: { "font-size": "16px" } }, [
                _c(
                  "span",
                  { staticStyle: { "font-family": "Calibri, sans-serif" } },
                  [
                    _vm._v(
                      "\n                        You have several choices regarding the use of information in relation to\n                        our services.\n                    "
                    ),
                  ]
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("li", [
              _c("span", { staticStyle: { "font-size": "16px" } }, [
                _c(
                  "span",
                  { staticStyle: { "font-family": "Calibri, sans-serif" } },
                  [
                    _vm._v(
                      "\n                        Email Communications. \n                    "
                    ),
                  ]
                ),
              ]),
            ]),
          ]
        ),
        _vm._v(" "),
        _c(
          "ol",
          {
            staticStyle: {
              "list-style-type": "lower-roman",
              "margin-left": "71px",
            },
          },
          [
            _c("li", [
              _c("span", { staticStyle: { "font-size": "16px" } }, [
                _c(
                  "span",
                  { staticStyle: { "font-family": "Calibri, sans-serif" } },
                  [
                    _vm._v(
                      "\n                        We will periodically send you free newsletters and e-mails that directly\n                        promote the use of our Site or Services.  When you receive\n                        newsletters or promotional communications from us, you may indicate a\n                        preference to stop receiving further communications from us and you will\n                        have the opportunity to “opt-out ”by following the\n                        unsubscribe instructions provided in the e-mail you receive or by\n                        contacting us directly (please see contact information below). Despite\n                        your indicated e-mail preferences, we may send you service related\n                        communications, including notices of any updates to our Terms of Use or\n                        Privacy Policy.\n                    "
                    ),
                  ]
                ),
              ]),
            ]),
          ]
        ),
        _vm._v(" "),
        _c(
          "ol",
          {
            staticStyle: {
              "list-style-type": "lower-alpha",
              "margin-left": "0.25in",
            },
            attrs: { start: "3" },
          },
          [
            _c("li", [
              _c("span", { staticStyle: { "font-size": "16px" } }, [
                _c(
                  "span",
                  { staticStyle: { "font-family": "Calibri, sans-serif" } },
                  [_vm._v("Cookies. ")]
                ),
              ]),
            ]),
          ]
        ),
        _vm._v(" "),
        _c(
          "ol",
          {
            staticStyle: {
              "list-style-type": "lower-roman",
              "margin-left": "71px",
            },
          },
          [
            _c("li", [
              _c("span", { staticStyle: { "font-size": "16px" } }, [
                _c(
                  "span",
                  { staticStyle: { "font-family": "Calibri, sans-serif" } },
                  [
                    _vm._v(
                      "\n                        If you decide at any time that you no longer wish to accept Cookies from\n                        our Service for any of the purposes described above, then you can\n                        instruct your browser, by changing its settings, to stop accepting\n                        Cookies or to prompt you before accepting a Cookie from the websites you\n                        visit. Consult your browser ’s technical information. If you do\n                        not accept Cookies, however, you may not be able to use all portions of\n                        the Service or all functionality of the Service. If you have any\n                        questions about how to disable or modify Cookies, please let us know at\n                        the contact information provided below.\n                    "
                    ),
                  ]
                ),
              ]),
            ]),
          ]
        ),
        _vm._v(" "),
        _c(
          "ol",
          {
            staticStyle: {
              "list-style-type": "lower-alpha",
              "margin-left": "0.25in",
            },
            attrs: { start: "4" },
          },
          [
            _c("li", [
              _c("span", { staticStyle: { "font-size": "16px" } }, [
                _c(
                  "span",
                  { staticStyle: { "font-family": "Calibri, sans-serif" } },
                  [
                    _vm._v(
                      "\n                        Changing or Deleting Your Personal Data. \n                    "
                    ),
                  ]
                ),
              ]),
            ]),
          ]
        ),
        _vm._v(" "),
        _c(
          "ol",
          {
            staticStyle: {
              "list-style-type": "lower-roman",
              "margin-left": "71px",
            },
          },
          [
            _c("li", [
              _c("span", { staticStyle: { "font-size": "16px" } }, [
                _c(
                  "span",
                  { staticStyle: { "font-family": "Calibri, sans-serif" } },
                  [
                    _vm._v(
                      "\n                        Users may make changes to their Personal Data through their Accounts.\n                        For Personal Data that cannot be changed via your Account, you may\n                        contact us at support@globalspaceexchange.com to request the change. We\n                        will use commercially reasonable efforts to honor your requests. We will\n                        never delete your Personal Data unless you contact us and ask us to do\n                        so.  If you completely delete all of your Personal Data, then your\n                        Account may become deactivated.  We may retain an archived copy of\n                        your records as required by law or for legitimate business purposes.\n                    "
                    ),
                  ]
                ),
              ]),
            ]),
          ]
        ),
        _vm._v(" "),
        _c(
          "h1",
          {
            staticStyle: {
              "margin-top": "12pt",
              "margin-right": "0in",
              "margin-bottom": "0.0001pt",
              "margin-left": "0.3in",
              "text-indent": "-0.3in",
              "line-height": "107%",
              "font-size": "16px",
              "font-family": "'Calibri Light', sans-serif",
            },
          },
          [
            _c("span", { staticStyle: { "font-size": "16px" } }, [
              _c(
                "span",
                { staticStyle: { "font-family": "Calibri, sans-serif" } },
                [
                  _vm._v(
                    "\n                    10. Security of Personal Data and Bank Account Information.\n                "
                  ),
                ]
              ),
            ]),
          ]
        ),
        _vm._v(" "),
        _c(
          "ol",
          {
            staticStyle: {
              "list-style-type": "lower-alpha",
              "margin-left": "0.5in",
            },
            attrs: { start: "1" },
          },
          [
            _c("li", [
              _c("span", { staticStyle: { "font-size": "16px" } }, [
                _c(
                  "span",
                  { staticStyle: { "font-family": "Calibri, sans-serif" } },
                  [
                    _vm._v(
                      "\n                        We have developed policies and procedures to keep your Personal Data\n                        confidential and secure. We restrict access to those employees and other\n                        persons who must use that information to provide services on our behalf.\n                        We maintain physical, electronic and procedural safeguards, in\n                        compliance with applicable laws, regulations and industry standards, to\n                        protect the confidentiality of the Personal Data we obtain.  We\n                        require our service providers to maintain the same level of\n                        confidentiality and security that we do. We continually update and\n                        improve our security standards and procedures to help protect against\n                        anyone gaining unauthorized access to your Personal Data and to prevent\n                        fraud.\n                    "
                    ),
                  ]
                ),
              ]),
            ]),
          ]
        ),
        _vm._v(" "),
        _c(
          "h1",
          {
            staticStyle: {
              "margin-top": "12pt",
              "margin-right": "0in",
              "margin-bottom": "0.0001pt",
              "margin-left": "0.3in",
              "text-indent": "-0.3in",
              "line-height": "107%",
              "font-size": "16px",
              "font-family": "'Calibri Light', sans-serif",
            },
          },
          [
            _c("span", { staticStyle: { "font-size": "16px" } }, [
              _c(
                "span",
                { staticStyle: { "font-family": "Calibri, sans-serif" } },
                [
                  _vm._v(
                    "\n                    11. Changes to This Privacy Policy\n                "
                  ),
                ]
              ),
            ]),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticStyle: {
              "margin-top": "0in",
              "margin-right": "0in",
              "margin-bottom": "8pt",
              "margin-left": "0in",
              "line-height": "107%",
              "font-size": "15px",
              "font-family": "'Calibri', sans-serif",
            },
          },
          [
            _c(
              "ol",
              {
                staticStyle: {
                  "margin-bottom": "0in",
                  "list-style-type": "lower-alpha",
                  "margin-left": "0.5in",
                },
                attrs: { start: "1" },
              },
              [
                _c(
                  "li",
                  {
                    staticStyle: {
                      "margin-top": "0in",
                      "margin-right": "0in",
                      "margin-bottom": "8pt",
                      "margin-left": "0in",
                      "line-height": "107%",
                      "font-size": "15px",
                      "font-family": "'Calibri', sans-serif",
                    },
                  },
                  [
                    _c(
                      "span",
                      {
                        staticStyle: {
                          "font-size": "16px",
                          "font-family": "Calibri, sans-serif",
                        },
                      },
                      [
                        _vm._v(
                          "\n                        This Privacy Policy is subject to occasional revision, and if we make\n                        any material changes in the way we use your Personal Data, we will\n                        notify you by sending you an e-mail to the last e-mail address you\n                        provided to us and/or by prominently posting notice of the changes on\n                        our Site. Any changes to this Privacy Policy will be effective upon the\n                        earlier of thirty (30) calendar days following our dispatch of an e-mail\n                        notice to you or thirty (30) calendar days following our posting of\n                        notice of the changes on our Site. These changes will be effective\n                        immediately for new users of our Service. Please note that at all times\n                        you are responsible for updating your Personal Data to provide us with\n                        your most current e-mail address. In the event that the last e-mail\n                        address that you have provided us is not valid, or for any reason is not\n                        capable of delivering to you the notice described above, our dispatch of\n                        the e-mail containing such notice will nonetheless constitute effective\n                        notice of the changes described in the notice. If you do not wish to\n                        permit changes in our use of your Personal Data, you must notify us\n                        prior to the effective date of the changes that you wish to deactivate\n                        your Account with us. Continued use of our Site or Service, following\n                        notice of such changes shall indicate your acknowledgement of such\n                        changes and agreement to be bound by the terms and conditions of such\n                        changes.\n                    "
                        ),
                      ]
                    ),
                  ]
                ),
              ]
            ),
          ]
        ),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }